// eslint-disable-next-line no-unused-vars
import { Typography, Box, Link, Stack } from "@mui/material"

// import HelpOutlineIcon from "@mui/icons-material/HelpOutline"

import useAppStore from "store/app"
// import RtlIconWrapper from "../../shared/RtlIconWrapper"
// import DangerCard from "../../shared/symptoms/DangerCard"
// import WarningCard from "../../shared/symptoms/WarningCard"
// import NormalCard from "../../shared/symptoms/NormalCard"
import DiseaseCode from "../../shared/DiseaseCode"
import ProgressLine from "../../shared/ProgressLine"
import { useTheme } from "@mui/material/styles"

const DiseaseItem = (props) => {
  const { number, item } = props

  const { setActiveDisease, toggleDrawer } = useAppStore((state) => state)
  const t = useAppStore((state) => state.translations)
  const theme = useTheme()

  const handleSelect = () => {
    setActiveDisease(item)
    toggleDrawer(true)
  }

  // const getSymptomCard = (item) => {
  //   if (item?.danger === "high") {
  //     return <DangerCard item={item} size="small" />
  //   } else if (item?.danger === "medium") {
  //     return <WarningCard item={item} size="small" />
  //   } else {
  //     return <NormalCard item={item} size="small" />
  //   }
  // }

  const percent = item.matching_percentage

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Stack direction="row" gap={1} alignItems="center">
          <Typography variant="body2" color="text.middle" sx={{ fontWeight: 600 }}>
            #{number + 1}
          </Typography>

          <Typography variant="body1" sx={{ mr: 1, fontWeight: 600 }}>
            {item.disease.name}
          </Typography>
        </Stack>

        <DiseaseCode icd10={item.disease.icd10} />
      </Box>

      <Link
        underline="hover"
        sx={{
          mt: 0.5,
          mb: 1,
          px: 0,
          cursor: "pointer",
          whiteSpace: "nowrap",
          fontSize: theme.direction === "rtl" ? "15px" : "13px",
        }}
        onClick={handleSelect}
      >
        {t?.data?.anamnesis?.more_disease}
      </Link>

      <ProgressLine percent={percent} />

      {/*<Stack direction="row" spacing={0.5} sx={{ mt: 1 }}>*/}
      {/*  {item.matching_symptoms.map((symptom, i) => (*/}
      {/*    <Box key={i}>{getSymptomCard(symptom)}</Box>*/}
      {/*  ))}*/}
      {/*</Stack>*/}

      {/*<RtlIconWrapper>*/}
      {/*  <IconButton*/}
      {/*    onClick={handleSelect}*/}
      {/*    sx={{ color: "primary.light", width: 24, height: 24, ml: 2 }}*/}
      {/*  >*/}
      {/*    <HelpOutlineIcon sx={{ width: 24, height: 24 }} />*/}
      {/*  </IconButton>*/}
      {/*</RtlIconWrapper>*/}
    </Box>
  )
}

export default DiseaseItem
